import { Component, Input } from '@angular/core';
import { ErrorInformation } from 'entities/error-information';
import { Observable, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { DownloadService } from 'services/download.service';
import { LoaderService } from 'services/loader.service';
import { OrderService } from 'services/order.service';
import { ToastService } from 'services/toast.service';

@Component({
    selector: 'order-invoice',
    templateUrl: './order-invoice.component.html',
    styleUrls: ['./order-invoice.component.scss'],
    standalone: false
})
export class OrderInvoiceComponent {
  @Input() invoiceNumber: string;

  isDisabled: boolean;

  private invoiceSubject: Subject<{}> = new Subject();
  public invoice$: Observable<boolean> = this.invoiceSubject
  .pipe(
    switchMap(() => {
      this.isDisabled = true;
      this.loader.loading = true;
      return this.orderService.getInvoice(this.invoiceNumber).pipe(
        map((invoice) => {
          if (invoice.pdf?.length) {
            const filename = `Invoice_${this.invoiceNumber}.pdf`;
            this.downloadService.downloadPDF(invoice.pdf, filename );
            this.loader.loading = false;
            return (true);
          } else {
            const error : ErrorInformation = {
              Message: invoice.message?.length ? invoice.message : 'Could not obtain invoice file to download'
            };
            this.toastService.errorMessage("OrderInvoiceComponent", "downloadInvoice", "downloadInvoice", error);
            this.loader.loading = false;
            return (false);
          }
        })
      );
    }),
    tap(() => this.isDisabled = false)
  );

  constructor(private orderService: OrderService,
    private toastService: ToastService,
    private downloadService: DownloadService,
    private loader: LoaderService) {
  }

  downloadInvoice() {
    this.invoiceSubject.next(null);
  }

}
